export const trendPaletaColores = [
  '#2D417A',
  '#812876',
  '#5D924B',
  '#B9232A',
  '#2C8C73',
  '#D04D2B',
  '#5FABCA',
  '#A93B83',
  '#FFB266',
  '#FF007F'
];

export class TrendPoint {
  constructor(
    public t: number,
    public v: number
  ) { }
}

export class CamaraTrendPoint {
  constructor(
    public t: number,
    public y: number
  ) { }
}

export class TrendDataTime {
  constructor(
    public deviceId: number,
    public variable: string,
    public startDate: number,
    public endDate: number,
    public step: number,
    public points: number,
    public values: TrendPoint[]
  ) { }
}

export class UsoSubeGraphRequest {
  constructor(
    public inicio: number,
    public fin: number,
    public dias: string[],
    public tipo: string,
    public lineas: string[],
    public contrato: number[]
  ) { }
}

export class UsoSubeTrendPoint {
  constructor(
    public c: number,
    public t: number,
    public p: number
  ) { }
}

export class UsoSubeGraphResponse {
  constructor(
    public inicio: number,
    public fin: number,
    public resultado: UsoSubeTrendPoint[],
    public comentario: string
  ) { }
}

export class CamaraTrendData {
  constructor(
    public startDate: number=1575509827000,
    public endDate: number=1575657427000,
    public idServer: number=0
  ) { }
}

export class CamaraDataPoint{
  constructor(
    public fecha: number,
    public camaras: number,
    public activas: number,
    public working: number
  ){}
}
export class CamaraTrendDataResult{
  constructor(
    public requestOk: boolean,
    public failureCause: string,
    public data:CamaraDataPoint[]
  ){}
}

export class InformationTableData {
    constructor(
      public curva: string,
      public minimo: number,
      public maximo: number,
      public promedio: number
    ) { }
  }
  